import "./App.css";
import React, { useState, useEffect } from "react";

import "./styles.scss";

import { Route, Routes } from "react-router-dom";
import MainHeader from "./components/MainHeader/MainHeader";
import About from "./components/About/About";
import Welcome from "./components/Welcome/Welcome";
import Lessons from "./components/Lessons/Lessons";
import LessonHOC from "./components/Lessons/LessonHOC";
import Footer from "./components/Footer/Footer";
import {
  FONT_SIZE,
  MOBILE_LAYOUT_QUERY,
  clampFontSize,
  pxToRem,
} from "./components/GlobalFuncs";

const App = () => {
  //Read the layout up front so the first render is already right: the lessons page sets
  //focus on mount based on it.
  const [showMobileNavMenu, setShowMobileNavMenu] = useState(
    () => window.matchMedia(MOBILE_LAYOUT_QUERY).matches
  );
  const [darkTheme, setDarkTheme] = useState(0);
  const [fontSize, setFontSize] = React.useState(FONT_SIZE.DEFAULT);
  const headerFontSize = pxToRem(
    clampFontSize(fontSize, FONT_SIZE.HEADER_MIN, FONT_SIZE.HEADER_MAX)
  );

  //Uses a media query rather than window.innerWidth: on mobile, content that overflows
  //the screen widens innerWidth, which kept the desktop header (and its buttons) off-screen.
  useEffect(() => {
    const mobileLayout = window.matchMedia(MOBILE_LAYOUT_QUERY);
    function handleLayoutChange() {
      setShowMobileNavMenu(mobileLayout.matches);
    }
    handleLayoutChange();
    mobileLayout.addEventListener("change", handleLayoutChange);

    return (_) => {
      mobileLayout.removeEventListener("change", handleLayoutChange);
    };
  }, []);
  return (
    <div className={Number(darkTheme) === 1 ? "app-dark" : "app-light"}>
      <MainHeader
        showMobileNavMenu={showMobileNavMenu}
        darkTheme={darkTheme}
        fontSize={fontSize}
        headerFontSize={headerFontSize}
        minFontSize={FONT_SIZE.MAIN_MIN}
        maxFontSize={FONT_SIZE.MAIN_MAX}
        onToggleClick={() => {
          setDarkTheme((darkTheme) => !darkTheme);
        }}
        onFontIncreaseClick={() => {
          setFontSize((fontSize) =>
            clampFontSize(
              fontSize + FONT_SIZE.STEP,
              FONT_SIZE.MAIN_MIN,
              FONT_SIZE.MAIN_MAX
            )
          );
        }}
        onFontDecreaseClick={() => {
          setFontSize((fontSize) =>
            clampFontSize(
              fontSize - FONT_SIZE.STEP,
              FONT_SIZE.MAIN_MIN,
              FONT_SIZE.MAIN_MAX
            )
          );
        }}
        onFontClick={() => {
          setFontSize(FONT_SIZE.DEFAULT);
        }}
      />

      <div
        className="main-wrapper"
        style={{
          fontSize: pxToRem(fontSize),
        }}
      >
        <main
          className={Number(darkTheme) === 1 ? "main-dark" : "main-light"}
          tabIndex={0}
        >
          <Routes>
            <Route exact path="/" element={<Welcome />}/>
            <Route path="lessons" element={<Lessons stackedLayout={showMobileNavMenu} />}/>
            <Route path="lessons/:lessonId" element={<LessonHOC/>} />
            <Route path="about" element={<About />} />
          </Routes>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default App;
